import React from "react";

const LoadingSpinner = ({
  size = "md",
  text = "",
  fullScreen = false,
  color = "blue",
}) => {
  // Size variants
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  // Color variants
  const colorClasses = {
    blue: "border-blue-600",
    white: "border-white",
    gray: "border-gray-600",
    green: "border-green-600",
    red: "border-red-600",
  };

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]} ${colorClasses[color]}`}
      ></div>
      {text && (
        <p
          className={`text-${
            color === "white" ? "white" : "gray-600"
          } text-sm font-medium`}
        >
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center h-[400px] w-full">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
